import { ChangeDetectionStrategy, Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { BaseResizableComponent } from '@src/app/modules/base';
import { PreviousRouteService } from '@src/core/services';

@Component({
  selector: 'lp-collection-list-header',
  templateUrl: './collection-list-header.component.html',
  styleUrls: ['./collection-list-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LpCollectionListHeaderComponent extends BaseResizableComponent {
  @Input() title?: string;
  @Output() add = new EventEmitter();

  private readonly previousRouteService = inject(PreviousRouteService);

  onClickBackButton() {
    this.previousRouteService.back('/loyalty');
  }
}
